export function inferEditorModeFromWorkProductContext(
    editorSurface: unknown,
    workProductType: unknown,
    workProductContentType: unknown,
    workProductPhase: unknown
): "rich-text" | "ide" {
    if (editorSurface === "ide" || editorSurface === "rich-text") return editorSurface;

    // Mirror the actual renderer behavior in WorkProductEditor:
    // CODE uses IDE; everything else currently uses the text editor.
    if (typeof workProductContentType === "string") {
        const normalizedContent = workProductContentType.trim().toUpperCase();
        if (normalizedContent === "CODE") return "ide";
        return "rich-text";
    }

    // Fallback only when content type is unavailable.
    if (typeof workProductPhase === "string") {
        const normalizedPhase = workProductPhase.trim().toLowerCase();
        if (normalizedPhase === "code") return "ide";
    }

    if (typeof workProductType === "string") {
        const normalized = workProductType.trim().toLowerCase().replace(/[_\s]+/g, "-");
        if (["code", "source", "ide", "ide-workspace"].includes(normalized)) return "ide";
    }

    return "rich-text";
}
